<template>

    <thead>
        <tr>
            <th v-if="is_lce_performance">Rang</th>

            <th>Dossard</th>
            <th>Nom - Prénom</th>
            <th v-if="!is_lce_performance">
                Indices de performances
                <v-btn variant="tonal" icon color="dark" size="x-small" height="20" width="20" class="ml-1">
                    <v-icon variant="elevated" elevation="0" icon="mdi-help"></v-icon>

                    <v-dialog v-model="dialog_indice_perf" activator="parent" width="500" max-width="100%"
                        scroll-strategy="none">
                        <v-card>
                            <v-card-text>
                                <div class="text-h6">Côte ITRA</div>
                                <v-chip color="black" variant="tonal" elevation="0" size="sm"
                                    class="chip_cotation mt-2 px-2"><img :src="require(`@/assets/img/logo_itra.png`)"
                                        class="chip_logo" /> <span class="chip_cote_text">500</span></v-chip>
                                <p>L'International Trail Running Association (ITRA) calcule pour chaque coureur une cote
                                    en fonction
                                    de la performance réalisée. La valeur maximale de la cote ITRA est de 1000 points.
                                </p>
                                <div class="text-h6">Indice de performance Sportips</div>
                                <v-chip color="orange-darken-4" variant="tonal" elevation="0" size="sm"
                                    class="chip_cotation px-2 mt-2"><img
                                        :src="require(`@/assets/img/logo_sportips_black.png`)" class="chip_logo" />
                                    <span class="chip_cote_text text-dark">50</span></v-chip>
                                <p>
                                    Chacune de vos courses Sportips courue depuis 2008, génère un indice qui est calculé
                                    selon votre
                                    classement.<br />
                                    Cet indice nous permet d'affiner l'estimation pour votre Suivi Live.<br />
                                    (*votre classement sexe* x 100) / (*participants du même sexe*). <br />
                                    La moyenne de tous vos indices est ensuite calculée, et affichée. Minimum 0 Maximum
                                    100.<br />
                                    Ex : un indice de 82/100 signifie que vous êtes mieux classé que 82% des autres
                                    coureurs du même
                                    sexe<br />
                                    95242 coureurs sont actuellement indexés.<br />
                                    Bonne course.
                                </p>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="dark" block variant="tonal"
                                    @click="dialog_indice_perf = false">Fermer</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-btn>
            </th>
            <th>Sexe</th>
            <th v-if="!hide_club">Club</th>
            <th v-if="!is_lce_performance">Parcours</th>
            <th v-if="mode == 'admin'">SAS/Vague départ</th>
            <th v-if="display_categorie_coureur">Cat.</th>
            <th v-if="!is_lce_performance">Document justificatif</th>
            <th v-if="!is_lce_performance">Validé</th>
            <th v-if="mode == 'admin'">Statut</th>
            <th v-if="is_lce_performance">Performance</th>

            <th v-if="is_lce_performance">Diplôme</th>
        </tr>
    </thead>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
export default {
    props: ["mode", "display_categorie_coureur"],
    name: 'BilletterieInscriptionThead',
    data() {
        return {
            dialog_indice_perf: false,
        }
    },
    computed: {
        ...mapStores(useMainStore),
        is_lce_performance() {
            return this.mode == 'lce_performance';
        },
        hide_club() {
            return this.mainStore.module.base == 'MAM26';
        }
    },
};
</script>

<style scoped>
.chip_logo {
    width: auto;
    height: 10px;
}

.chip_cote_text {
    margin-top: 2px;
    font-size: 1.1rem;
    margin-left: 5px;
    font-weight: bold;
}

.chip_cotation {
    height: 20px;
}

th {
    font-size: 11px !important;
}

/* Your styles go here */
</style>